<template>
  <div class="content-block news-image-text-link-slide">
    <NuxtLink
      :to="
        item.linkDefault
          ? localePath(item.linkDefault)
          : localePath({ name: 'news-slug', params: { slug: item.slug } })
      "
      :target="item.linkDefault ? '_blank' : '_self'"
    >
      <div class="content-block__swiper__slide">
        <div
          v-if="imageSource.length"
          class="content-block__swiper__slide__image"
        >
          <WidgetPicture
            :image="{ custom: imageSource[0] }"
            :alt="imageSource[0]?.title"
          />
          <div v-if="props.type === 'video'" class="play-icon">
            <PlayIcon :filled="true" />
          </div>
        </div>
        <div class="content-block__swiper__slide__text">
          <div
            v-if="item?.title"
            class="content-block__swiper__slide__title title-base"
          >
            <div v-html="item.title" />
          </div>
          <div
            v-if="item?.text"
            class="content-block__swiper__slide__description text-base"
          >
            <div v-html="item.text" />
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import PlayIcon from '@/assets/img/ico/play.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
})

const imageSource = computed(() => {
  return props.type === 'video'
    ? props.item.portrait
    : props.item.sezioneContenutoPagina[0].custom
})
</script>

<script>
export default {
  name: 'PagesNewsImageTextLinkSwiperSlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
